export default __webpack_public_path__ + "static/media/research-network.fb4aa4ee.jpg";